import Cookie from "js-cookie";
import getUrlParams from "../getUrlParams";
import type { CookieAttributes } from "./cookie.types";

function getDomain() {
	// get the last 2 segments of the hostname if the hostname ends with .com
	// this will ignore anyone connecting to a server via IP
	const match = /[^.]+\.com$/.exec(window.location.hostname);
	return match && match.length > 0 ? match[0] : window.location.hostname;
}

type SetCookieFunc = (value: string, opts?: CookieAttributes) => void;

export default (
	cookieName: string,
	urlParams: string | string[] = [],
): [string | undefined, SetCookieFunc] => {
	const localUrlParams =
		typeof urlParams === "string" ? [urlParams] : urlParams;
	const urlData: string = localUrlParams.reduce((acc, val) => {
		if (acc !== "") {
			return acc;
		}
		const valueFromUrl = getUrlParams(val, { firstParamOnly: true });
		if (valueFromUrl) {
			return valueFromUrl;
		}
		return acc;
	}, "");

	const cookieData: string | undefined = Cookie.get(cookieName);

	const getData = () => {
		return urlData || cookieData;
	};

	const setData: SetCookieFunc = (value, opts = {}) => {
		Cookie.set(cookieName, value, {
			expires: 30,
			domain: getDomain(),
			...opts,
		});
	};

	if (urlData) {
		setData(urlData);
	}

	return [getData(), setData] as const;
};
